import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import Core from '../../../class/Core';
import InputMask from 'react-input-mask';
import moment from 'moment';
import 'moment/locale/pt-br';

//actions
import * as UserActions from '../../../actions/UserActions';
import * as ManagerStatusActions from '../../../actions/StatusManagerActions.js';
import * as RedirectActions from '../../../actions/RedirectActions';
import * as StatusActions from '../../../actions/StatusActions';
import { isNull } from 'util';

class PagamentosRetornos extends React.Component{
    constructor(props){
        super(props);
        this.core = new Core();
        this.width = window.innerWidth * 0.66 ;
        this.height = this.width * window.innerHeight / window.innerWidth ;
        //define locale moment
        moment.locale('pt-BR');
        this.state = {
            relatorio: [],
            renderModal: <div></div>,
            selecao: {},
            trabs: [],
            qtd_total: 0,
            vlr_total: 0,
            qtd_arquivos: 0,
            qtd_total_BSF: 0,
            vlr_total_BSF: 0,
            qtd_arquivos_BSF: 0

        }

        this.getTableShow = this.getTableShow.bind(this);
        this.handlerSubmit = this.handlerSubmit.bind(this);
    }

    componentWillMount(){
        this.props.action.showManager();
        this.props.action.redirectClear();
    }

    handlerSubmit(event){
        event.preventDefault();
        let self = this;

        let data = {
        }

        data.data_pagto = event.target.data_pagto.value;
        data.data_baixa = event.target.data_baixa.value;

        this.props.action.loadingStatus();

            fetch(self.core.getUrl() + self.core.getVersionAPI() + "empresa/relatorios/resumopagamentosretornos", {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'Authorization': self.core.formatAutorizationToken(self.core.getToken())
                },
                method: 'POST',
                body: JSON.stringify(data)
            })
            .then(res => self.core.responseConvert(res))
            .then((response) => {
                let vlr_pago = 0
                let qtd_pago = 0
                let qtd_arquivos = 0
                let vlr_pago_BSF = 0
                let qtd_pago_BSF = 0
                let qtd_arquivos_BSF = 0
                let nome_arq = null
                response.content.map ((val, index) => {
                    nome_arq = val.arquivo_ret
                    console.log ("Nome Arquivo=>", val.arquivo_ret);
                    if (!isNull(nome_arq)) {
                        if (nome_arq.indexOf("(*)") != -1) {
                            vlr_pago_BSF += parseFloat(val.vlr_pagamentos)
                            qtd_pago_BSF += parseFloat(val.qtd_pagamentos)  
                            qtd_arquivos_BSF++;  
                        }  else {
                            vlr_pago += parseFloat(val.vlr_pagamentos)
                            qtd_pago += parseFloat(val.qtd_pagamentos)  
                            qtd_arquivos++;  
                        }  
                    }
                })
                self.setState({
                    relatorio: response.content, 
                    qtd_arquivos: qtd_arquivos,
                    qtd_total: qtd_pago,
                    vlr_total: vlr_pago,
                    qtd_arquivos_BSF: qtd_arquivos_BSF,
                    qtd_total_BSF: qtd_pago_BSF,
                    vlr_total_BSF: vlr_pago_BSF
                });
                self.props.action.loadedStatus();
            })
            .catch((err) => {
                self.core.catchFecth(err)
                self.props.action.loadedStatus();
            });
    }

    getTableShow(){
        return this.state.relatorio.map((data, index) => {
            return <tr key={index} >
                <td>{data.arquivo_ret}</td>
                <td style={{textAlign:"right"}}>{data.qtd_pagamentos.toLocaleString('de-DE')}</td>
                <td style={{textAlign:"right"}}>R$ {parseFloat(data.vlr_pagamentos).toLocaleString('de-DE')}</td>
            </tr>
        });
    }

    render(){
        let tableContent;
        if(this.props.redirect.url){
            return <Redirect to={this.props.redirect.url} />;
        }

        if(this.state.relatorio.length){
            tableContent = this.getTableShow();
        }else{
            tableContent = <tr>
                <td colSpan={3}>
                    <center>
                        <b>Informe os parametros necessários para a pesquisa.</b>
                    </center>
                </td>
            </tr>
        }

        return <div className="page">
            <div className="page-content">
                <h2>Pagamentos - Retorno CNAB</h2>
                <p>Consulte o total dos pagamentos por Arquivos de Retorno (CNAB)</p>

                <div className="panel">
                    <div className='panel-title'>
                        <h3>
                            Informe a Data de Pagamento ou Data Baixa para a pesquisa de pagamentos
                        </h3>
                        <div  className="seleciona-mes-doc" >
                            <form onSubmit={this.handlerSubmit}>
                                <div className="row">
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <InputMask name="data_pagto" id="data_pagto2" placeholder="Data Pagamento" className="form-control" mask="99/99/9999" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <InputMask name="data_baixa" id="data_baixa2" placeholder="Data Baixa" className="form-control" mask="99/99/9999" />
                                        </div>
                                    </div>
                                    <div className="col-sm-1">
                                        <button type="Submit" className="btn btn-primary">pesquisar</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                        
                    <div className="panel-body container-fluid">
                        <table className="table table-striped table-doc">
                            <tr>
                                <thead>
                                <td>Totais</td>
                                <td>Qtd Arquivos BSF</td>
                                <td>Qtd Títulos Pagos BSF</td>
                                <td>Valor Total Pago BSF</td>
                                <td>Qtd Arquivos Gestão e Cobrança</td>
                                <td>Qtd Títulos Pagos Gestão e Cobrança</td>
                                <td>Valor Total Pago Gestão e Cobrança</td>
                                </thead>
                                <tbody>
                                <td></td>
                                <td>{this.state.qtd_arquivos_BSF}</td>
                                <td style={{textAlign:"right"}}>{this.state.qtd_total_BSF.toLocaleString('de-DE')}</td>
                                <td style={{textAlign:"right"}}>R$ {this.state.vlr_total_BSF.toLocaleString('de-DE')}</td>
                                <td>{this.state.qtd_arquivos}</td>
                                <td style={{textAlign:"right"}}>{this.state.qtd_total.toLocaleString('de-DE')}</td>
                                <td style={{textAlign:"right"}}>R$ {this.state.vlr_total.toLocaleString('de-DE')}</td>
                                </tbody>
                            </tr>
                        </table>

                        <table className="table table-striped table-doc">
                            <thead>
                                <tr>
                                    <td>Arquivo Retorno</td>
                                    <td style={{textAlign:"right"}}>Qtd Pagamentos</td>
                                    <td style={{textAlign:"right"}}>Valor Pagamentos</td>
                                </tr>
                            </thead>
                            <tbody>
                                {tableContent}
                            </tbody>
                        </table>
                    </div>
                </div> 


            </div>
        </div>
    }
}

function mapStateProps(state, props) {
    return {
        user: state.user,
        managerStatus: state.managerStatus,
        redirect: state.redirectReducer
    }
}

function mapDispatchProps(dispatch) {
    return {
        action: bindActionCreators({
            ...UserActions,
            ...ManagerStatusActions,
            ...RedirectActions,
            ...StatusActions
        }, dispatch)
    }
}
export default withRouter(connect(mapStateProps, mapDispatchProps)(PagamentosRetornos))
